var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_148_711",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.936523,
    y: 0.301941,
    width: 38.583,
    height: 38.583,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_148_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2759 32.9327L31.5609 28.6478V32.1599H32.983V26.224H27.0472V27.6462H30.5592L26.2743 31.9311L27.2759 32.9327ZM29.876 36.5653C27.8685 36.5653 26.1609 35.8615 24.7532 34.4538C23.3455 33.0461 22.6417 31.3385 22.6417 29.3311C22.6417 27.3236 23.3455 25.616 24.7532 24.2083C26.1609 22.8006 27.8685 22.0968 29.876 22.0968C31.8834 22.0968 33.591 22.8006 34.9987 24.2083C36.4064 25.616 37.1102 27.3236 37.1102 29.3311C37.1102 31.3385 36.4064 33.0461 34.9987 34.4538C33.591 35.8615 31.8834 36.5653 29.876 36.5653ZM12.594 14.5533H27.8664V12.1419H12.594V14.5533ZM19.5841 33.2573H9.47153C8.66978 33.2573 7.985 32.9734 7.41719 32.4056C6.84935 31.8378 6.56543 31.153 6.56543 30.3512V8.8339C6.56543 8.03215 6.84935 7.34737 7.41719 6.77956C7.985 6.21172 8.66978 5.9278 9.47153 5.9278H30.9889C31.7906 5.9278 32.4754 6.21172 33.0432 6.77956C33.6111 7.34737 33.895 8.03215 33.895 8.8339V19.002C33.2416 18.73 32.5841 18.5234 31.9225 18.3822C31.2609 18.2411 30.5788 18.1705 29.876 18.1705C29.4575 18.1705 29.0567 18.1952 28.6733 18.2447C28.2899 18.2941 27.9076 18.3714 27.5263 18.4765V18.3869H12.594V20.7982H22.8117C22.1645 21.3053 21.59 21.8808 21.0882 22.5249C20.5863 23.169 20.1622 23.8713 19.816 24.6319H12.594V27.0433H19.0523C18.9678 27.4039 18.906 27.7631 18.8668 28.1207C18.8277 28.4783 18.8081 28.8508 18.8081 29.2383C18.8081 29.9267 18.8627 30.6089 18.972 31.2849C19.0812 31.9609 19.2852 32.6184 19.5841 33.2573Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportNotes);
export default __webpack_public_path__ + "static/media/export_notes.88cf964383da490fe598700a4dbeffed.svg";
export { ForwardRef as ReactComponent };